import { createSelector } from 'reselect'
import getLoyaltyLoungePassItemViews from '../itemViews/getLoyaltyLoungePassItemViews'
import { sum } from 'lib/array/arrayUtils'
import { knownPriceBreakdownTitle } from 'checkout/constants/priceBreakdownTitles'
import { getCurrentIntl } from 'i18n/util/currentIntl'

const getLoyaltyLoungePassBreakdownView = createSelector(
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (itemView): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (itemView.data.length === 0) {
      return {
        hasRequiredData: true,
        data: [],
      }
    }

    const freeTickets = itemView.data.filter(data => data.totals.price === 0)
    const paidTickets = itemView.data.filter(data => data.totals.price > 0)
    const intl = getCurrentIntl()

    const formatTicketLine = (count: number, total: number, id: string) => ({
      id,
      left: {
        type: 'text' as const,
        value: intl.formatMessage(
          {
            id: '1nOK38lPiFnxscPIKHCj',
            defaultMessage: '{count}x {count, plural, one {ticket} other {tickets}}',
            description: 'Ticket count for loyalty lounge pass breakdown in the checkout flow',
          },
          { count },
        ),
      },
      right: {
        type: 'price' as const,
        value: total,
      },
    })

    const additionalElements: Array<App.Checkout.ItemBreakdownElement> = []
    if (freeTickets.length > 0) {
      additionalElements.push(formatTicketLine(freeTickets.length, 0, 'free-tickets'))
    }
    if (paidTickets.length > 0) {
      additionalElements.push(formatTicketLine(paidTickets.length, sum(paidTickets, data => data.totals.price), 'paid-tickets'))
    }

    return {
      data: [{
        title: knownPriceBreakdownTitle('airportLoungePass'),
        additionalInfoText: [],
        price: 0,
        memberPrice: 0,
        itemsAlwaysVisible: true,
        items: [{
          itemType: 'loungePassItem',
          title: '',
          additionalElements,
          additionalInfo: [],
        }],
      }],
      hasRequiredData: itemView.hasRequiredData,
    }
  },
)

export default getLoyaltyLoungePassBreakdownView
